import React, { useEffect, useState } from 'react';
import { formatTimeUntilMidnight } from '../../../utils/timezoneUtils';

const CalendarCountdown = ({ todayCompleted = false, onMidnightReset }) => {
  const [timeLeft, setTimeLeft] = useState('');
  const [lastTimeLeft, setLastTimeLeft] = useState('');

  useEffect(() => {
    const updateTimer = () => {
      const newTimeLeft = formatTimeUntilMidnight();

      // Check if we just crossed midnight (time reset from a small value to ~24:00:00)
      if (lastTimeLeft && lastTimeLeft.startsWith('00:00:0') && newTimeLeft.startsWith('23:5')) {
        // Trigger refresh callback when midnight reset is detected
        if (onMidnightReset) {
          setTimeout(() => {
            onMidnightReset();
          }, 1000); // Small delay to ensure new day has started
        }
      }

      setLastTimeLeft(timeLeft);
      setTimeLeft(newTimeLeft);
    };

    // Update immediately
    updateTimer();

    // Update every second
    const interval = setInterval(updateTimer, 1000);

    return () => clearInterval(interval);
  }, [timeLeft, lastTimeLeft, onMidnightReset]);

  if (todayCompleted) {
    return (
      <div className="text-center mb-3">
        <div className="bg-green-50 border border-green-200 rounded-md px-2 py-1 inline-flex items-center gap-2">
          <span className="text-xs text-green-600">🎉 All tasks completed!</span>
          <span className="text-sm font-mono font-bold text-green-600">{timeLeft}</span>
        </div>
      </div>
    );
  }

  return (
    <div className="text-center mb-3">
      <div className="bg-orange-50 border border-orange-200 rounded-md px-2 py-1 inline-flex items-center gap-2">
        <span className="text-xs text-gray-600">Reset in:</span>
        <span className="text-sm font-mono font-bold text-orange-600">{timeLeft}</span>
      </div>
    </div>
  );
};

export default CalendarCountdown;
